import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IOrderDetails } from "interfaces/IOrder";
import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { primaryColor, primaryColorOpacity } from "utils/colors";
import { ProductRow } from "./ProductRow";
import { useState } from "react";
import { parseDateDDMMYYY } from "../../../helpers/dates";
import { currencyMXN } from "../../../helpers/numbers";

/**
 * Custom props for the upper section of the details
 */
interface Props {
    /**
     * The order details state
     */
    order: IOrderDetails;
}

export const FooterSection = ({ order }: Props) => {
    const [quantity, setQuantity] = useState<number>(0);
    const [subtotal, setSubtotal] = useState<number>(0);

    /**
     * handles the quantity from child component
     */
    const handleQuantity = (value: number) => {
        setQuantity(value);
    }

    /**
     * handles the Subtotal from child component
     */
    const handleSubtotal = (value: number) => {
        setSubtotal(value);
    }

    return (
        <Col xs={12}>
            <div className="d-flex align-items-center">
                <Form.Label>
                    <strong> Detalle de la compra:</strong>
                </Form.Label>
                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={
                        <Tooltip className="custom-tooltip text-unwrap">
                            <div className="text-start">
                                El detalle de la compra muestra la información <br />
                                completa de la compra, esto incluye el producto, <br />
                                la talla, el color, precio unitario, la cantidad y el <br />
                                total.
                            </div>
                        </Tooltip>
                    }
                >
                    <FontAwesomeIcon icon={faInfoCircle} className="ms-2 mb-1" />
                </OverlayTrigger>
            </div>
            <div
                style={{
                    backgroundColor: primaryColorOpacity,
                    border: `2px solid ${primaryColor}`,
                    borderRadius: "9px",
                    padding: "10px 20px 0 20px",
                    marginBottom: "20px",
                    boxShadow: "0 10px 20px 0 rgba(0, 0, 0, 0.4)"
                }}
            >
                <Table className="table-borderless" >
                    <thead>
                        <tr className="bg-inherit">
                            <th className="text-center" style={{ width: "50%" }}><strong className="bg-inherit">Producto</strong></th>
                            <th className="text-center" ><strong className="bg-inherit">Precio unitario</strong></th>
                            <th className="text-center" ><strong className="bg-inherit">Cantidad</strong></th>
                            <th className="text-center" ><strong className="bg-inherit">Total</strong></th>
                        </tr>
                    </thead>
                    {order.order_products?.map(product => (
                        <ProductRow
                            key={`Product row ${product.product_id}`}
                            product={product}
                            handleQuantity={handleQuantity}
                            handleSubtotal={handleSubtotal}
                        />
                    ))}
                    <tfoot className="bg-inherit">
                        <tr className="bg-inherit text-center">
                            <td></td>
                            <td className="text-start"><strong className="bg-inherit">Subtotal</strong></td>
                            <td>{quantity}</td>
                            <td>{currencyMXN(subtotal)}</td>
                        </tr>
                        <tr className="text-center">
                            <td></td>
                            <td className="bborder text-start"><strong className="bg-inherit">Costos de envío</strong></td>
                            <td className="bborder"></td>
                            <td className="bborder">{currencyMXN(order?.total - subtotal)}</td>
                        </tr>
                        <tr className="text-center">
                            <td></td>
                            <td className="text-start"><strong className="bg-inherit">Total</strong></td>
                            <td>{quantity}</td>
                            <td>{currencyMXN(order?.total)}</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
            <Row>
                {(order.status === "En tránsito" || order.status === "Entregado") &&
                    <div className="d-flex flex-no-wrap justify-content-evenly">
                        <Form.Label  >
                            <strong> Servicio de mensajería</strong> <br />
                            {order.tracking_name}
                        </Form.Label>
                        <Form.Label  >
                            <strong>Guía del envío:</strong> <br />
                            {order.tracking_number}
                        </Form.Label>
                        {order.estimated_delivery &&
                            <Form.Label  >
                                <strong>Fecha estimada de entrega:</strong> <br />
                                {parseDateDDMMYYY(new Date(order.estimated_delivery))}
                            </Form.Label>
                        }
                    </div>
                }
            </Row>
        </Col>
    )
}
